import { Grid } from '@mui/material';
import { WsColors } from 'wisestep-base';

import { formatNumberInLocale } from '../../../../../utils/NumberFormatter';
import CountWithTextCard from '../../../components/countWithTextCard';
import { ICountWithTextCard } from '../../../components/countWithTextCard/CountWithTextCard';

const CustomCountWithTextCard = ({ count, text }: ICountWithTextCard) => (
  <Grid
    container
    bgcolor={WsColors.White}
    p={2}
    mb={1}
    mt={1}
    justifyContent="center"
    alignItems="center"
  >
    <CountWithTextCard count={formatNumberInLocale(Number(count)) ?? 0} text={text} />
  </Grid>
);

export default CustomCountWithTextCard;
